import { Component } from '@opten/gin-tonic/helpers/compiler';
import { Counter } from '@opten/gin-tonic/components/counter';

@Component({className: 'js-counter'})
export class CounterComponent {
	counter: Counter;

	constructor(public element: HTMLElement) {
		const option = {
			separator: '’',
		};
		this.counter = new Counter(element, option);
	}
}
